import { Binoculars } from 'lucide-react';
import { PageHeader } from '../components/ui/PageHeader';
import { ComingSoon } from '../components/ui/ComingSoon';

export function AccountExplorerPage() {
  return (
    <>
      <PageHeader
        icon={Binoculars}
        title="Account Explorer"
        description="Connect a Pinterest account and browse boards, pins, and profile."
      />
      <ComingSoon what="Account Explorer UI" />
    </>
  );
}
